function compose(...functions: Function[]) {
  return functions.reduce(
    (a, b) =>
      (...args) =>
        a(b(...args)),
    (arg) => arg,
  );
}

export default compose;
